import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Hint from '../../../../../../components/hint';
import { Theme } from '../../../../../../theme';
import DurationFormat from '../../../../components/DurationFormat';
import { AutoBreaksRules } from '../../../../components/AutoBreaks/shared';
import { getBreakLegislationDisplayInfo } from '../../../../components/AutoBreaks/suggestBreaks/breakLegislationLookup';

type Props = {
  actualBreakDuration: number;
  minBreakDuration: number;
  autoBreakRules: AutoBreaksRules | null;
  breakTypeId: string | null | undefined;
};

export const BreakDuration: React.FC<Props> = ({
  actualBreakDuration,
  minBreakDuration,
  autoBreakRules,
  breakTypeId,
}) => {
  const { t } = useTranslation();

  const { countsTowardRequiredBreak, breakTypeName } =
    getBreakLegislationDisplayInfo(autoBreakRules, breakTypeId);

  const isShort =
    minBreakDuration > 0 && actualBreakDuration < minBreakDuration;
  const showAsterisk = !countsTowardRequiredBreak || isShort;

  if (!showAsterisk) {
    return (
      <Container>
        <DurationFormat minutes={actualBreakDuration} />
      </Container>
    );
  }

  const tooltipText = !countsTowardRequiredBreak
    ? breakTypeName
      ? t('timeTrackingNew.hintBreakIsNotCountedExcludedTypeNamed', {
          name: breakTypeName,
        })
      : t('timeTrackingNew.hintBreakIsNotCountedExcludedTypeGeneric')
    : t('timeTrackingNew.hintBreakIsNotCounted', {
        count: minBreakDuration,
      });

  const hintId = !countsTowardRequiredBreak
    ? 'hintBreakExcludedFromLegislation'
    : 'hintBreakIsNotCounted';

  return (
    <Hint id={hintId} text={tooltipText}>
      <Container>
        <DurationFormat minutes={actualBreakDuration} />
        <Asterisk>*</Asterisk>
      </Container>
    </Hint>
  );
};

const Container = styled('div')({
  color: Theme.color.dark,
  position: 'relative',
});

const Asterisk = styled('span')({
  position: 'absolute',
});
